import {
  View,
  Text,
  Image,
  StyleSheet,
  TouchableOpacity,
  Linking,
  Platform,
  SafeAreaView,
  ImageBackground
} from 'react-native'
import React, { useState, useEffect } from 'react'
// styles
import {
  colorPalette,
  globalStyles,
  fontPalette
} from '../../static/styles/global'

// types
import { LoginParams } from '../../types/authTypes'

// i18n
import i18next from '../../i18n/i18next'
import { useTranslation } from 'react-i18next'
import { RadioButton } from 'react-native-paper'
import { AntDesign, Feather } from '@expo/vector-icons'

import AsyncStorage from '@react-native-async-storage/async-storage'

const LoginScreen = ({ request, action }: LoginParams): JSX.Element => {
  const { t, i18n } = useTranslation()
  const [selectedOption, setSelectedOption] = useState(
    i18n.language === 'SPA' ? 'Spanish' : 'English'
  )

  const [isopenDropDown, setIsOpenDropDown] = useState<boolean>(false)

  useEffect(() => {
    if (i18n.language) {
      setSelectedOption(i18n.language === 'SPA' ? 'Spanish' : 'English')
    }
  }, [i18n.language])

  const handleOptionClick = async (option: string) => {
    setSelectedOption(option)
    setIsOpenDropDown(false)
    const langCode = option === 'English' ? 'ENG' : 'SPA'
    try {
      await AsyncStorage.setItem('selectedLanguage', langCode)
    } catch (e) {
      console.error('Error saving language selection', e)
    }
    i18next.changeLanguage(langCode)
  }

  const handleImagePress = () => {
    Linking.openURL(
      'https://play.google.com/store/apps/details?id=com.fmssolutions.onboardingapp'
    )
  }
  const handleImagePress1 = () => {
    Linking.openURL('https://apps.apple.com/us/app/workhappy/id6450463466')
  }

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.contentContainer}>
        {/* Logo Wrapper */}
        <View style={styles.logoWrapper}>
          <Image
            source={require('../../static/images/workhappy_logo1.png')}
            style={styles.logo}
            resizeMode="contain"
          />
        </View>

        {/* Headline / Header Text */}
        <View style={styles.headerTextWrapper}>
          <Text style={styles.greenText}>
            {t('moreThanOnboarding', 'More Than Onboarding.')}
          </Text>
          <Text style={styles.navyText}>
            {t('aBetterEmployee', 'A Better Employee')}
          </Text>
          <Text style={styles.navyText}>{t('experience', 'Experience.')}</Text>
        </View>

        {/* Language Selection Dropdown */}
        <View style={styles.dropdownContainer}>
          <TouchableOpacity
            onPress={() => setIsOpenDropDown(!isopenDropDown)}
            style={styles.dropdownButton}
          >
            <View style={styles.dropdownLeft}>
              <Feather name="globe" size={24} color="#063652" />
              <Text style={styles.dropdownText}>
                {t('selectlanguage', 'Select Language')}
              </Text>
            </View>
            {isopenDropDown ? (
              <AntDesign name="up" size={18} color="#78A02D" />
            ) : (
              <AntDesign name="down" size={18} color="#78A02D" />
            )}
          </TouchableOpacity>

          {isopenDropDown && (
            <View style={styles.dropdownOptions}>
              <View style={styles.optionRow}>
                <Text style={styles.optionText}>English</Text>
                <RadioButton
                  status={
                    selectedOption === 'English' ? 'checked' : 'unchecked'
                  }
                  onPress={() => handleOptionClick('English')}
                  value="English"
                  color="#063652"
                />
              </View>
              <View style={styles.optionRow}>
                <Text style={styles.optionText}>Spanish</Text>
                <RadioButton
                  status={
                    selectedOption === 'Spanish' ? 'checked' : 'unchecked'
                  }
                  onPress={() => handleOptionClick('Spanish')}
                  value="Spanish"
                  color="#063652"
                />
              </View>
            </View>
          )}
        </View>

        {/* Login Button */}
        <TouchableOpacity
          onPress={action}
          style={styles.loginButton}
          activeOpacity={0.8}
        >
          <Text style={styles.loginButtonText}>{t('login', 'Login')}</Text>
          <Feather
            name="arrow-right"
            size={20}
            color="#ffffff"
            style={styles.loginButtonArrow}
          />
        </TouchableOpacity>

        {/* Powered by FMS */}
        <View style={styles.poweredByWrapper}>
          <Text style={styles.poweredByText}>
            {t('Poweredby', 'Powered by')}
          </Text>
          <Image
            source={require('../../static/images/fms_logo_3x.png')}
            style={styles.fmsLogo}
            resizeMode="contain"
          />
        </View>
      </View>
      <View style={styles.bottomWaveContainer}>
        <ImageBackground
          source={require('../../static/images/login_bottom_wave.png')}
          resizeMode="cover"
          style={styles.image}
        ></ImageBackground>
      </View>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    justifyContent: 'space-between'
  },
  contentContainer: {
    flex: 1,
    paddingHorizontal: 28,
    paddingTop: Platform.OS === 'ios' ? 40 : 60,
    zIndex: 2
  },
  logoWrapper: {
    alignItems: 'center',
    marginBottom: 40,
    marginTop: 20
  },
  logo: {
    width: 280,
    height: 80
  },
  headerTextWrapper: {
    alignItems: 'center',
    marginBottom: 40
  },
  greenText: {
    fontFamily: fontPalette.primaryBold,
    fontSize: 26,
    color: '#78A02D',
    textAlign: 'center',
    marginBottom: 4
  },
  navyText: {
    fontFamily: fontPalette.primaryBold,
    fontSize: 26,
    color: '#063652',
    textAlign: 'center',
    lineHeight: 34
  },
  dropdownContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 14,
    marginBottom: 20,
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 12,
    elevation: 4
  },
  dropdownButton: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  dropdownLeft: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  dropdownText: {
    fontFamily: fontPalette.primarySemiBold,
    fontSize: 16,
    color: '#43525A',
    marginLeft: 12
  },
  dropdownOptions: {
    marginTop: 12,
    borderTopWidth: 1,
    borderTopColor: '#EFEFEF',
    paddingTop: 8
  },
  optionRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 6
  },
  optionText: {
    fontFamily: fontPalette.primaryRegular,
    fontSize: 15,
    color: '#43525A'
  },
  loginButton: {
    backgroundColor: '#063652',
    borderRadius: 12,
    height: 52,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    marginBottom: 30,
    shadowColor: '#063652',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 4
  },
  loginButtonText: {
    fontFamily: fontPalette.primaryBold,
    fontSize: 16,
    color: '#FFFFFF'
  },
  loginButtonArrow: {
    position: 'absolute',
    right: 20
  },
  poweredByWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20
  },
  poweredByText: {
    fontFamily: fontPalette.primaryRegular,
    fontSize: 13,
    color: '#7F7F7F',
    marginRight: 6
  },
  fmsLogo: {
    width: 165,
    height: 135,

  },
  bottomWaveContainer: {
    width: '100%',
    height: 220,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1
  },
  image: {
    flex: 1,
    justifyContent: 'center'
  }
})

export default LoginScreen
